import {Injectable} from '@angular/core';
import appConfig from '../config/app-config';

declare var gtag: Function; // Declaring gtag function

@Injectable({
  providedIn: 'root'
})

export class GoogleAnalyticsService {
  trackButtonClick(eventModel: any) {
    gtag('event', appConfig.googleAnalyticsKey, eventModel);
  }
}
